/* eslint-disable id-length */
import { Series, SeriesData } from "~/components/job/Job/HostedCompute/types";
import { ChartDataset, ChartOptions } from "chart.js";
import { merge } from "lodash";

export const convertToChartDatasets = (data: Series): ChartDataset<"line", number[]>[] => {
  return Object.keys(data)
    .filter((key) => key !== "timestamps")
    .map((key) => ({
      label: key,
      data: (data[key] as SeriesData).values,
    }));
};

const TIME_FORMAT = "HH:mm:ss";

const displayFormats = {
  second: TIME_FORMAT,
  minute: TIME_FORMAT,
  hour: TIME_FORMAT,
};

const hostedComputeOptions: ChartOptions = {
  plugins: {
    tooltip: {
      backgroundColor: "#FFFFFF",
      titleColor: "#333333",
      bodyColor: "#333333",
      borderColor: "#DDDDDD",
      borderWidth: 1,
      cornerRadius: 6,
      padding: 12,
      boxWidth: 12,
      boxHeight: 12,
      boxPadding: 4,
      titleFont: { weight: 600, size: 12 },
      bodyFont: { size: 12 },
      callbacks: {
        labelColor: (context) => {
          const color = context.dataset.borderColor as string;
          return {
            borderColor: "transparent",
            backgroundColor: color,
            borderRadius: 2,
          };
        },
      },
    },
  },
  scales: {
    x: {
      time: {
        displayFormats,
        tooltipFormat: "MMM D, HH:mm:ss",
      },
      afterBuildTicks: (axis) => {
        const { min, max, ticks } = axis;
        if (ticks.length < 2 || !Number.isFinite(min) || !Number.isFinite(max) || max <= min) {
          return;
        }
        const step = (max - min) / (ticks.length - 1);
        axis.ticks = ticks.map((_tick, index) => ({ value: min + step * index }));
      },
    },
  },
};

export function chartOptionsOverride(...overrides: ChartOptions[]): ChartOptions {
  return merge({}, hostedComputeOptions, ...overrides);
}

export function tooltipValueFormat(format: (value: number) => string): ChartOptions {
  return {
    plugins: {
      tooltip: {
        callbacks: {
          label: (context) => `${context.dataset.label}: ${format(context.parsed.y as number)}`,
        },
      },
    },
  };
}
